'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowThickRight = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.606 11.278l-8.8-8.771a1 1 0 0 0-1.706.708V8.24a.25.25 0 0 1-.25.25H1.1a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h11.75a.25.25 0 0 1 .25.25v5.043a1 1 0 0 0 1.707.707l8.8-8.8a1 1 0 0 0 0-1.416z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M14.099 21.787a.992.992 0 0 1-.706-.292 1.005 1.005 0 0 1-.294-.708V15.99H1.1c-.551 0-1-.448-1-1v-6c0-.551.449-1 1-1h12V3.216a1.001 1.001 0 0 1 1.706-.708l8.8 8.771a.999.999 0 0 1 .002 1.415l-8.801 8.801a.997.997 0 0 1-.708.292zM1.1 14.99h12.499a.5.5 0 0 1 .5.5v5.298l8.8-8.8L14.1 3.216V8.49a.5.5 0 0 1-.5.5H1.1v6z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M12.001 21.999a1.488 1.488 0 0 1-1.163-.551 1.5 1.5 0 0 1-.338-.963V17.5h-9a1.49 1.49 0 0 1-1.063-.445A1.491 1.491 0 0 1 0 15.991V8.506a1.485 1.485 0 0 1 .437-1.061A1.494 1.494 0 0 1 1.497 7H10.5V4.008a1.478 1.478 0 0 1 .43-1.057 1.49 1.49 0 0 1 1.055-.449c.359.002.699.123.963.339l10.488 8.233a1.515 1.515 0 0 1 .218 2.139c-.062.074-.13.143-.204.204L12.936 21.67c-.257.21-.591.329-.935.329zM1.5 15.994l9.75.006a.75.75 0 0 1 .75.75v3.742l10.51-8.245-10.5-8.236L12 7.75a.75.75 0 0 1-.75.75H1.503L1.5 15.994z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowThickRight.displayName = 'IconArrowThickRight';
exports.default = IconArrowThickRight;